export default __webpack_public_path__ + "static/media/phpmyadmin.8e9b4ad3.svg";